// src/utils/auth.ts
import Cookies from "universal-cookie";

const cookies = new Cookies();

// ✅ 너 프로젝트에서 실제로 쓰는 쿠키 키로 통일
export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";

// (예전 admin-token을 아직 쓰면 같이 제거)
export const LEGACY_ADMIN_TOKEN_KEY = "admin-token";

export const isAuthenticated = (): boolean => {
  const at = cookies.get(ACCESS_TOKEN_KEY);
  return Boolean(at);
};

export const getAccessToken = (): string | undefined => cookies.get(ACCESS_TOKEN_KEY);
export const getRefreshToken = (): string | undefined => cookies.get(REFRESH_TOKEN_KEY);

export const setTokens = (accessToken: string, refreshToken?: string) => {
  cookies.set(ACCESS_TOKEN_KEY, accessToken, { path: "/", sameSite: "lax" });
  if (refreshToken) {
    cookies.set(REFRESH_TOKEN_KEY, refreshToken, { path: "/", sameSite: "lax" });
  }
};

export const clearTokens = () => {
  cookies.remove(ACCESS_TOKEN_KEY, { path: "/" });
  cookies.remove(REFRESH_TOKEN_KEY, { path: "/" });
  cookies.remove(LEGACY_ADMIN_TOKEN_KEY, { path: "/" }); // ✅ 혹시 남아있으면 같이 제거
};
